
   const firebaseConfig = {
    apiKey: "AIzaSyBptUtQlbjyd7fea8bP0raMfOrseBvQq-s",
    authDomain: "plant-store-8df04.firebaseapp.com",
    projectId: "plant-store-8df04",
    storageBucket: "plant-store-8df04.appspot.com",
    messagingSenderId: "213723215222",
    appId: "1:213723215222:web:05e91702b006f5255eb657"
  };

  export default firebaseConfig;